import { ENVIRONMENT, ENVIRONMENT_TYPE } from './common';

export const INACTIVITY_TIMEOUT = 1000 * 60 * 30; // 30 minutes in milliseconds
export const APP_STORE_URL = {
  ANDROID: 'https://play.google.com/store/apps/details?id=mx.org.montepio',
  IOS: 'https://apps.apple.com/mx/app/montep%C3%ADo-luz-savi%C3%B1%C3%B3n/id6503148645',
};

const APP_ANDROID_PACKAGE_LIST = {
  [ENVIRONMENT_TYPE.DEVELOPMENT]: 'mx.org.montepio.pre',
  [ENVIRONMENT_TYPE.PREPRODUCTION]: 'mx.org.montepio.pre',
  [ENVIRONMENT_TYPE.STAGING]: 'mx.org.montepio.staging',
  [ENVIRONMENT_TYPE.PRODUCTION]: 'mx.org.montepio',
};

export const APP_ANDROID_PACKAGE = APP_ANDROID_PACKAGE_LIST[ENVIRONMENT] || APP_ANDROID_PACKAGE_LIST[ENVIRONMENT_TYPE.STAGING];

export const PAWNED_CATEGORY = {
  WATCHES: 'Relojes',
  JEWELRY: 'Alhajas',
  CARS: 'Autos',
  DIAMONDS: 'Diamantes',
};

export const RESPONSE_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const ERROR_LOADING_DATA = 'ERROR_LOADING_DATA';

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const OTP_LENGTH = window.OTP_LENGTH || 4;

export const PROVIDER_TYPE = {
  BANCOMER: 'BANCOMER',
  PAYCASH: 'PAYCASH',
  PUNTORED: 'PUNTORED',
  MERCADO_PAGO: 'MERCADO_PAGO',
};

export const CONTRACT_STATUS = {
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
  CANCELED: 'CANCELED',
  PAYMENT_SAP_PENDING: 'PAYMENT_SAP_PENDING',
  PENDING_SAP_CON: 'PENDING_SAP_CON',
  FAILED: 'FAILED',
  PENDING_3DS_CHALLENGE: 'PENDING_3DS_CHALLENGE',
};

export const USER_LEVEL = {
  BASIC: 'BASIC',
  COMPLETE: 'COMPLETE',
};

export const LOGIN_TYPES = {
  CLIENT_ID: 'CLIENT_ID',
  EMAIL: 'EMAIL',
};

export const OTP_TYPES = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
};

export const CONTRACT = 'CONTRACT';
export const SECTION = 'SECTION';

export const SECTION_PAYMENT_OPTIONS_KEYS = {
  EXTENSION: 'extension',
  MINIMUM: 'minimum',
  SUGGESTED: 'suggested',
  ABONO_20: 'abono20',
};

export const PAYCASH_MAX_AMOUNT = 8000;
export const SECTION_MIN_AMOUNT = 20;

export const PAYMENT_OPTIONS_KEYS = {
  PAGO_MINIMO: '1503',
  PAGO_MINIMO_2: '1514',
  EXTENSION_PA: '1515',
  EXTENSION: '1225',
  EXTENSION_A: '1230',
  EXTENSION_EXT: '1235',
  EXTENSION_EXT_A: '1240',
  LIQUIDACION: '1205',
  LIQUIDACION_A: '1219',
  LIQUIDACION_PA: '1513',
};

export const PHONE_COUNTRY_CODE = '+52';

export const LOCAL_STORAGE_PREFIX = 'mls-';
export const WINDOW_VAR_NOTICES = 'notices';
export const WHATSAPP_SUPPORT_PHONE = '+525515210534';
export const WHATSAPP_SUPPORT_URL = `https://wa.me/${WHATSAPP_SUPPORT_PHONE.replace('+', '')}`;
